var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16C5.22379 16 0.40183 8.92308 0.172213 8.61539C-0.0574043 8.30769 -0.0574043 7.84615 0.172213 7.53846C0.40183 7.23077 5.22379 0 11.5 0C17.7762 0 22.5982 7.23077 22.8278 7.53846C23.0574 7.84615 23.0574 8.30769 22.8278 8.61539C22.5982 8.92308 17.7762 16 11.5 16ZM2.23877 8.07692C3.46339 9.61539 7.21381 14 11.5 14C15.7862 14 19.6131 9.61539 20.7612 8.07692C19.5366 6.46154 15.7862 1.92308 11.5 1.92308C7.21381 1.92308 3.38686 6.46154 2.23877 8.07692Z",
    fill: "#717579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13C9 13 7 10.7778 7 8C7 5.22222 9 3 11.5 3C14 3 16 5.22222 16 8C16 10.7778 14 13 11.5 13ZM11.5 4.98413C10 4.98413 8.78571 6.33333 8.78571 8C8.78571 9.66667 10 11.0159 11.5 11.0159C13 11.0159 14.2143 9.66667 14.2143 8C14.2143 6.33333 13 4.98413 11.5 4.98413Z",
    fill: "#717579"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.51774c44.svg";
export { ForwardRef as ReactComponent };